import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWorkspace } from "models/IWorkspace";

interface IActiveWorkspaceState {
    value: IWorkspace | null;
};

const initialState: IActiveWorkspaceState = {
    value: null
};

const activeWorkspaceSlice = createSlice({
    name: "activeWorkspace",
    initialState,
    reducers: {
        setActiveWorkspace(state, action: PayloadAction<IWorkspace>) {
            state.value = action.payload;
        },
        clearActiveWorkspace(state) {
            state.value = null;
        }
    }
});

export const { setActiveWorkspace, clearActiveWorkspace } = activeWorkspaceSlice.actions;
export default activeWorkspaceSlice.reducer;